import { Avatar, Dropdown, type MenuProps } from 'antd';
import type React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconLogout } from 'src/components/icons/icon-logout/icon-logout';
import { GAHeaderDimensionName, GAHeaderEvent } from 'src/constants';
import { useUser, useUserActions } from 'src/hooks/data/user';
import { sendGAEvent } from 'src/services/analytics/ga';

export const Profile: React.FC = () => {
  const user = useUser();
  const { signOut } = useUserActions();

  if (!user) {
    return null;
  }

  const items: MenuProps['items'] = [
    {
      label: (
        <div className="flex gap-x-8 items-center group-hover:font-medium">
          <IconLogout />
          <FormattedMessage id="logout" />
        </div>
      ),
      key: 'logout',
      className: 'group',
      onClick: () => {
        signOut();
        sendGAEvent(GAHeaderEvent.HEADER_CLICKS, {
          [GAHeaderDimensionName.HEADER]: 'user_menu_logout',
        });
      },
    },
  ];

  return (
    <Dropdown
      trigger={['click']}
      menu={{ items }}
      classNames={{ root: 'min-w-[102px]' }}
      placement="bottomLeft"
      onOpenChange={(open) => {
        if (open) {
          sendGAEvent(GAHeaderEvent.HEADER_CLICKS, {
            [GAHeaderDimensionName.HEADER]: 'user_menu',
          });
        }
      }}
    >
      <div className="flex items-center gap-x-8 px-8 py-4 cursor-pointer rounded-lg hover:bg-extra-gray-8 duration-100">
        <Avatar className="bg-primary text-[16px]/[24px]">{user?.username?.[0].toUpperCase()}</Avatar>

        <span className="flex flex-col">
          <span className="text-[14px]/[22px]">{user?.username}</span>
          <span className="text-[12px]/[20px] text-gray-6 -mt-2">UTC+00:00</span>
        </span>
      </div>
    </Dropdown>
  );
};
